import { render, staticRenderFns } from "./archivedOrderQuery.vue?vue&type=template&id=92c5d598&scoped=true"
import script from "./archivedOrderQuery.vue?vue&type=script&lang=js"
export * from "./archivedOrderQuery.vue?vue&type=script&lang=js"
import style0 from "./archivedOrderQuery.vue?vue&type=style&index=0&id=92c5d598&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c5d598",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92c5d598')) {
      api.createRecord('92c5d598', component.options)
    } else {
      api.reload('92c5d598', component.options)
    }
    module.hot.accept("./archivedOrderQuery.vue?vue&type=template&id=92c5d598&scoped=true", function () {
      api.rerender('92c5d598', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/expressAndlargOrder/archivedOrderQuery.vue"
export default component.exports